<template>
  <Modal
    @close="$emit('close')"
    :showModal="showModal"
    :isLoading="isLoading"
    class="modal-address-validation"
  >
    <template v-slot:header>
      <div class="modal-address-validation__header">
        {{ $t('account.addressBook.addressValidation') }}
      </div>
    </template>
    <template v-slot:body>
      <p class="modal-address-validation__sub-title">
        {{ $t('account.addressBook.addressValidationSubTitle') }}
      </p>
      <div class="modal-address-validation__hint-wrapper">
        <div class="modal-address-validation__hint-container">
          <h3 class="text-h5 modal-address-validation__address-title">{{ $t('account.addressBook.entered') }}</h3>
          <div>
            <AddressItem :data="enteredData" />
          </div>
        </div>
        <div class="modal-address-validation__hint-container">
          <h3 class="text-h5 modal-address-validation__address-title">{{ $t('account.addressBook.suggested') }}</h3>
          <div>
            <AddressItem :data="suggestedData" />
          </div>
        </div>
      </div>
    </template>
    <template v-slot:footer>
      <div class="modal__actions">
        <button
          @click="$emit('close')"
          type="button"
          class="button button--outlined"
        >
          {{ $t('common.cancel') }}
        </button>
        <button
          @click="$emit('confirm', suggestedData)"
          type="button"
          class="button button--primary"
        >
          {{ $t('account.addressBook.updateAddress') }}
        </button>
      </div>
      <div class="modal-address-validation__bottom-copy-wrap">
        <i18n path="account.addressBook.contactUsCopy" tag="p">
          <a class="link" href="/customer-support" target="_blank">{{ $t('account.addressBook.contactUsLinkText') }}</a>
        </i18n>
      </div>
    </template>
  </Modal>
</template>

<script>
import AddressItem from '@/components/AddressItem'
import Modal from '@/components/modal/Modal'

export default {
  name: 'ModalAddressValidation',
  components: {
    AddressItem,
    Modal
  },
  props: ['showModal', 'enteredData', 'suggestedData', 'isLoading']
}
</script>
